import React from "react";
import ShopBreadcumb from "../components/ourshop/ShopBreadcumb";
// import ShopArea from "../components/ourshop/ShopArea";

function ShopPages() {
  return (
    <main>
      <ShopBreadcumb />
      <section className="blog-area pt-110 pb-60">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-9">
              <div className="section-title text-center mb-65">
                <div className="section-icon">
                  <img src="img/icon/pawprint.png" alt="" />
                </div>
                <h5 className="sub-title">
                  ¡Pronto Abriremos Nuestra Tienda de Mascotas!
                </h5>
                <h2 className="title">
                  Aquí encontrarás todo lo que necesitas para consentir a tu
                  mejor amigo
                </h2>
                <p>
                  Estamos trabajando arduamente para traerte una tienda llena de
                  productos esenciales y adorables para tus mascotas. Lo mejor
                  de todo es que un porcentaje de cada venta será donado a
                  refugios de animales necesitados. Así, no solo estarás
                  consentido a tu peludo, sino que también estarás ayudando a
                  otros animales en busca de un hogar. ¡Mantente atento, estamos
                  casi listos para abrir!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <ShopArea /> */}
    </main>
  );
}
export default ShopPages;
